import {createContext} from 'react'
//export const OpenLinksContext = createContext({urls:[],add:(url:string)=>{}});
const emptyArray:any=[]
export interface UrlItem{
    key:string,
    title:string,
    url:string,
    ts:number
  }

export type UrlItemArray = UrlItem[]
export const OpenLinksContext = createContext({
    routes:{urls:emptyArray,active:0},
    menus:emptyArray,
    init:false,
    add:(key:string,title:string,url:string)=>{},
    remove:(index:number)=>{},
    active:(index:number)=>{},
    reload:(index:number)=>{},
});